import miniProgram from '@assets/miniProgram.png'
import wechat_qrcode from '@assets/wechat_qrcode.png'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { OfficialInfoData } from '@/network/api/global/type'

import Copyright from './copyright'
import styles from './index.module.css'

interface FooterProps {
  officialData?: OfficialInfoData
}

const DEFAULT_CONTACT_EMAIL = 'admin@yun3d.com'
const DEFAULT_CONTACT_PHONE = '400-000-0000'

const FooterXzz = ({ officialData }: FooterProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const contactEmail = officialData?.email || DEFAULT_CONTACT_EMAIL
  const contactPhone = officialData?.phone || DEFAULT_CONTACT_PHONE

  const qrcodeItems = [
    {
      key: 'mini-program',
      src: officialData?.miniProgramQrcodeUrl || miniProgram,
      fallback: miniProgram,
      label: t('footer.miniProgram'),
    },
    {
      key: 'wechat',
      src: officialData?.wechatQrcodeUrl || wechat_qrcode,
      fallback: wechat_qrcode,
      label: t('footer.follow'),
    },
  ]

  return (
    <footer className="w-full">
      <div className={styles.main}>
        <div className={styles.inner}>
          <div className={styles.links}>
            <section className={styles.section}>
              <div className={styles.sectionTitle}>{t('footer.contact')}</div>
              <div className={styles.contactList}>
                <div className={styles.contactItem}>
                  <i className="iconfont icon-youxiang" />
                  <span>{contactEmail}</span>
                </div>
                <div className={styles.contactItem}>
                  <i className="iconfont icon-shouji" />
                  <span>{contactPhone}</span>
                </div>
              </div>
            </section>

            <section className={styles.section}>
              <div className={styles.sectionTitle}>{t('footer.service')}</div>
              <button type="button" className={styles.serviceLink} onClick={() => navigate('/material')}>
                {t('footer.material')}
              </button>
            </section>
          </div>

          <div className={styles.qrcodeGroup}>
            {qrcodeItems.map((item) => (
              <div key={item.key} className={styles.qrcodeItem}>
                <img
                  src={item.src}
                  alt={item.label}
                  onError={(e) => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = item.fallback
                  }}
                />
                <div className={styles.qrcodeLabel}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Copyright />
    </footer>
  )
}

export default FooterXzz
